import React, { useState } from 'react';
// ====== constante login interaccion de usuarios======
const TercerComponente = ({ currentUser, onClose, setUserLogueado }) => {
  const [appointmentData, setAppointmentData] = useState({
    tipo: 'Controles medicos',
    fecha: '',
    hora: '',
    mascota: '',
    propietario: currentUser?.nombre || '',
    identificacion: currentUser?.identificacion || '',
    telefono: currentUser?.celular || '',
    email: currentUser?.email || '',
    notas: '',
    atendido: false
  });
// ====== registro de medidas de citas ======
  const tiposCita = ['Urgencias', 'Controles medicos', 'Vacunas', 'Valoracion', 'Estetica'];

  const handleAppointment = (e) => {
    e.preventDefault();
    
    if (!appointmentData.email || !appointmentData.telefono) {
      alert('Por favor complete los datos de contacto');
      return;
    }
    
    const nuevaCita = {
      id: Date.now(),
      tipo: appointmentData.tipo,
      fecha: appointmentData.fecha,
      hora: appointmentData.hora,
      mascota: appointmentData.mascota.toUpperCase(),
      propietario: appointmentData.propietario.toUpperCase(),
      identificacion: appointmentData.identificacion,
      telefono: appointmentData.telefono,
      email: appointmentData.email,
      notas: appointmentData.notas,
      atendido: false,
      fechaAgendada: new Date().toLocaleString('es-CO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      })
    };

    const citas = JSON.parse(localStorage.getItem('citas')) || [];
    citas.push(nuevaCita);
    localStorage.setItem('citas', JSON.stringify(citas));

    alert('Cita agendada exitosamente');
    onClose();
  };

  const handleAppointmentChange = (e) => {
    const { name, value } = e.target;
    setAppointmentData(prev => ({ ...prev, [name]: value }));
  };

  const styles = {
    container: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: '2rem',
      borderRadius: '2px',
      boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
      width: '50%',
      maxWidth: '450px',
      zIndex: 500
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    heading: {
      textAlign: 'center',
      marginBottom: '1rem',
      color: '#333'
    },
    input: {
      padding: '0.45rem',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '1rem'
    },
    select: {
      padding: '0.75rem',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '1rem',
      backgroundColor: 'white'
    },
    textarea: {
      padding: '0.75rem',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '1rem',
      minHeight: '10px'
    },
    formActions: {
      display: 'flex',
      gap: '1rem',
      marginTop: '1rem'
    },
    primaryButton: {
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      padding: '0.75rem',
      borderRadius: '4px',
      cursor: 'pointer',
      flex: 1,
      fontSize: '1rem'
    },
    secondaryButton: {
      backgroundColor: '#6c757d',
      color: 'white',
      border: 'none',
      padding: '0.75rem',
      borderRadius: '4px',
      cursor: 'pointer',
      flex: 1,
      fontSize: '1rem'
    },
    inputGroup: {
      display: 'flex',
      gap: '0.5rem'
    },
    contactInfo: {
      backgroundColor: '#f8f9fa',
      padding: '0.75rem',
      borderRadius: '1px',
      marginBottom: '0.5rem'
    }
  };
// ====== constante retornos data correctos o false error ======
  return (
    <div style={styles.container}>
      <form style={styles.form} onSubmit={handleAppointment}>
        <h3 style={styles.heading}>Agendar Cita</h3>
        
        
        
        <select
          name="tipo"
          value={appointmentData.tipo}
          onChange={handleAppointmentChange}
          required
          style={styles.select}
        >
          {tiposCita.map((tipo) => (
            <option key={tipo} value={tipo}>{tipo}</option>
          ))}
        </select>
        
        <div style={styles.inputGroup}>
          <input
            type="date"
            name="fecha"
            value={appointmentData.fecha}
            onChange={handleAppointmentChange}
            required
            style={{ ...styles.input, flex: 1 }}
          />
          <input
            type="time"
            name="hora"
            value={appointmentData.hora}
            onChange={handleAppointmentChange}
            required
            style={{ ...styles.input, flex: 1 }}
          />
        </div>
        
        <input
          type="text"
          name="mascota"
          placeholder="Nombre de la mascota"
          value={appointmentData.mascota}
          onChange={handleAppointmentChange}
          required
          style={styles.input}
        />
        
        <input
          type="text"
          name="propietario"
          placeholder="Nombre del propietario"
          value={appointmentData.propietario}
          onChange={handleAppointmentChange}
          required
          style={styles.input}
        />
        
        <input
          type="text"
          name="identificacion"
          placeholder="Identificación del propietario"
          value={appointmentData.identificacion}
          onChange={handleAppointmentChange}
          style={styles.input}
        />
        
        <input
          type="email"
          name="email"
          placeholder="Correo electrónico"
          value={appointmentData.email}
          onChange={handleAppointmentChange}
          required
          style={styles.input}
        />
        
        <input
          type="tel"
          name="telefono"
          placeholder="Teléfono de contacto"
          value={appointmentData.telefono}
          onChange={handleAppointmentChange}
          required
          style={styles.input}
        />
        
        <textarea
          name="notas"
          placeholder="Notas adicionales"
          value={appointmentData.notas}
          onChange={handleAppointmentChange}
          style={styles.textarea}
        />
        
        <div style={styles.formActions}>
          <button type="submit" style={styles.primaryButton}>Agendar</button>
          <button type="button" style={styles.secondaryButton} onClick={onClose}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default TercerComponente;

// ====== constantes personalizacion de mascotas de usuarios======